import { useMemo } from 'react'

import { useStytchMember } from '@stytch/react/b2b'

type UseCurrentUser = () => {
  email: string | undefined
  id: string | undefined
}

export const useCurrentUser: UseCurrentUser = () => {
  const { member } = useStytchMember()

  const email = useMemo(() => {
    if (!member) return undefined
    return member.email_address
  }, [member])

  return {
    email,
    id: member?.trusted_metadata?.sequenceUserId as string | undefined
  }
}
